import React from 'react'
import { IonModal, IonItem, IonInput, IonContent } from '@ionic/react'
import { getContacts } from '../../../service/api/bot'
import Header from '../../../components/Header'
import 'react-virtualized/styles.css'
import AutoSizer from 'react-virtualized/dist/commonjs/AutoSizer'
import List from 'react-virtualized/dist/commonjs/List'
import RadioItem from '../../../components/RadioItem'

export type ContactsType = {
    contacts_type: string
    describe: string
    head_url: string
    name: string
    uid: string
}

interface PushServiceContactListProps {
    value: ContactsType[]
    isShow: boolean
    onClose: (list?: ContactsType[]) => void
    type: 'FRIEND' | 'GROUP'
}

const PushServiceContactList: React.FC<PushServiceContactListProps> = (
    props
) => {
    const [list, setList] = React.useState<ContactsType[]>([])
    const [selected, setSelected] = React.useState<{
        [key: string]: ContactsType | undefined
    }>({})

    React.useEffect(() => {
        if (props.isShow) {
            getContacts({ contacts_type: props.type }).then((res: any) => {
                setSelected(
                    props.value.reduce((pre, curr) => {
                        pre[curr.uid] = curr
                        return pre
                    }, {})
                )
                setList(res.wechaty_contacts_list)
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.isShow])

    const search = (keyword: string) => {
        getContacts({
            contacts_type: props.type,
            keyword: keyword ? keyword : undefined,
        }).then((res: any) => {
            setList(res.wechaty_contacts_list)
        })
    }

    function ListItem({ key, index, style }) {
        return (
            <IonItem
                key={list[index].uid}
                className='groupListItem'
                style={style}
                onClick={() =>
                    setSelected((v) => {
                        return {
                            ...v,
                            [list[index].uid]: selected[list[index].uid]
                                ? undefined
                                : list[index],
                        }
                    })
                }
            >
                <RadioItem
                    className='contact-radio-item'
                    selected={!!selected[list[index].uid]}
                    onSelect={() =>
                        setSelected((v) => {
                            return {
                                ...v,
                                [list[index].uid]: selected[list[index].uid]
                                    ? undefined
                                    : list[index],
                            }
                        })
                    }
                />
                <img
                    src={list[index].head_url}
                    alt='headPhoto'
                    className='groupListItemImg'
                />
                <p>{list[index].name}</p>
            </IonItem>
        )
    }
    return (
        <IonModal isOpen={props.isShow}>
            <IonContent className='mybot-content'>
                <Header
                    backable
                    title={props.type === 'GROUP' ? '群组选择' : '好友选择'}
                    onBack={() => props.onClose()}
                >
                    <button
                        className='contact-option-button'
                        onClick={() => {
                            props.onClose(
                                Object.values(selected)
                                    .filter(Boolean)
                                    .map((item) => ({ ...item })) as any
                            )
                        }}
                    >
                        确定
                    </button>
                </Header>
                <IonItem>
                    <IonInput
                        placeholder='筛选'
                        debounce={500}
                        onIonChange={(e) => search(e.detail.value!)}
                    />
                </IonItem>
                <div style={{ height: 1000 }}>
                    <AutoSizer>
                        {({ width, height }) => (
                            <List
                                width={width}
                                height={height}
                                overscanRowCount={10}
                                rowCount={list.length}
                                rowHeight={50}
                                rowRenderer={ListItem}
                            />
                        )}
                    </AutoSizer>
                </div>
            </IonContent>
        </IonModal>
    )
}

export default PushServiceContactList
